import { EventResult } from '../shared/types'
import getDefaultCompleteResult from '../util/getDefaultCompleteResult'

export const getPreviousResult = (eventResult: EventResult, round: number) => {
  return eventResult.games[round].results
}

export const getDefaultResults = (players: string[]) => {
  const defaultResults = {
    [players[0]]: 0,
    [players[1]]: 0,
    [players[2]]: 0,
  }
  if (players.length === 4) {
    defaultResults[players[3]] = 0
  }
  return defaultResults
}
const getPlayerResultsForEachRound = (eventResult: EventResult) => {
  const completeResults = { ...getDefaultCompleteResult(eventResult.players) }

  const calcutedEventResult = { ...eventResult }
  // completeResult zurücksetzen
  calcutedEventResult.results = getDefaultCompleteResult(eventResult.players)

  eventResult && Object.keys(calcutedEventResult.games).map((round, index) => {
    const roundNumber = parseInt(round, 10)
    const roundData = calcutedEventResult.games[roundNumber]

    const newResults = roundNumber === 1 ? getDefaultResults(eventResult.players) : { ...getPreviousResult(eventResult, roundNumber - 1) }
    if (roundData.player) {
      // wenn gewonnen, dann drauf rechnen, wenn verloren, dann doppelt abziehen (außer bei Hand, dann nur einfach)
      if (roundData.won) {
        completeResults[roundData.player].wonOffense = completeResults[roundData.player].wonOffense + 1
        newResults[roundData.player] = newResults[roundData.player] + (roundData.gameValue || 0)
      } else {
        completeResults[roundData.player].lostOffense = completeResults[roundData.player].lostOffense + 1
        // bei anderen Spielern lostDefense + 1
        Object.keys(newResults).map(player => {
          if (player !== roundData.player) {
            completeResults[player].lostDefense = completeResults[player].lostDefense + 1
          }
        })
        const factor = roundData.hand ? 1 : 2
        newResults[roundData.player] = newResults[roundData.player] - ((roundData.gameValue || 0) * factor)
      }
      // completeResult übertragen
      completeResults[roundData.player].sessionResult = newResults[roundData.player]
    }
    calcutedEventResult.results = completeResults
    calcutedEventResult.games[roundNumber].results = { ...newResults }
  })
  // calculate complete game
  const factor = calcutedEventResult.players.length === 4 ? 30 : 40
  Object.keys(calcutedEventResult.results).map(player => {
    calcutedEventResult.results[player] = {
      ...calcutedEventResult.results[player],
      completeResult:
        calcutedEventResult.results[player].sessionResult +
        ((calcutedEventResult.results[player].wonOffense - calcutedEventResult.results[player].lostOffense) * 50) +
        (calcutedEventResult.results[player].lostDefense * factor),
    }
    return (calcutedEventResult.results[player])
  })
  return calcutedEventResult
}

export default getPlayerResultsForEachRound
